import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
var DEFAULT_FILTER_OPTIONS = [{
  title: '包含',
  key: 'contain',
  filter: function filter(value) {
    return function (data) {
      if (data == null) {
        return false;
      }
      if (typeof data === 'number') {
        data = data + '';
      }
      return _includesInstanceProperty(data).call(data, value[0]);
    };
  }
}, {
  title: '不包含',
  key: 'notContain',
  filter: function filter(value) {
    return function (data) {
      if (data == null) {
        return true;
      }
      if (typeof data === 'number') {
        data = data + '';
      }
      return !_includesInstanceProperty(data).call(data, value[0]);
    };
  }
}, {
  title: '等于',
  key: 'equal',
  filter: function filter(value) {
    return function (data) {
      return value[0] === data;
    };
  }
}, {
  title: '不等于',
  key: 'notEqual',
  filter: function filter(value) {
    return function (data) {
      return value[0] !== data;
    };
  }
}, {
  title: '为空',
  key: 'isNull',
  filter: function filter() {
    return function (data) {
      return !data;
    };
  }
}, {
  title: '不为空',
  key: 'notIsNull',
  filter: function filter() {
    return function (data) {
      return !!data;
    };
  }
}];
export { DEFAULT_FILTER_OPTIONS };